// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#pathMenuContainer[data-v-715904af]{display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:60%}.align-document-title[data-v-715904af]{left:232px!important;word-wrap:break-word;max-width:60%!important}.break-word[data-v-715904af]{word-wrap:break-word}", ""]);
// Exports
module.exports = exports;
